export default __webpack_public_path__ + "static/media/phone.ad86adb1.svg";